// ─────────────────────────────────────────────────────────────
// SUPABASE SCHEMA — run in the Supabase SQL editor when setting up.
// ─────────────────────────────────────────────────────────────

export const SCHEMA_SQL = `
CREATE TABLE IF NOT EXISTS trades (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  created_at TIMESTAMPTZ DEFAULT NOW(),
  updated_at TIMESTAMPTZ DEFAULT NOW(),
  trade_date DATE DEFAULT CURRENT_DATE,
  trade_time TIME DEFAULT CURRENT_TIME,
  symbol TEXT NOT NULL,
  direction TEXT NOT NULL,
  entry_price NUMERIC,
  exit_price NUMERIC,
  position_size NUMERIC DEFAULT 1,
  stop_loss NUMERIC,
  take_profit NUMERIC,
  pnl NUMERIC,
  result TEXT,
  setup_type TEXT,
  discipline_score INTEGER,
  duration_minutes INTEGER,
  notes TEXT,
  mental_state TEXT,
  emotional_intensity INTEGER,
  trade_behaviors TEXT[],
  trend_aligned BOOLEAN DEFAULT false,
  setup_valid BOOLEAN DEFAULT false,
  risk_ok BOOLEAN DEFAULT false,
  is_closed BOOLEAN DEFAULT true,
  version INT DEFAULT 1,
  
  -- 🆕 BEHAVIOR ANALYTICS COLUMNS (Phase 1-2)
  decision_speed TEXT,           -- "fast" | "moderate" | "overthink"
  conviction_level INTEGER,      -- 1-10 (entered PRE-trade)
  entry_signal TEXT,             -- "ma_cross" | "support_bounce" | "breakout" | etc.
  fear_level INTEGER,            -- 1-10 (entered POST-trade)
  greed_level INTEGER,           -- 1-10 (entered POST-trade)
  market_condition TEXT,         -- "trending_up" | "trending_down" | "ranging" | "volatile"
  rule_violations TEXT[],        -- ["risked_too_much", "no_stop_loss", "emotional_entry"]
  exit_reason TEXT,              -- "target_hit" | "stop_hit" | "manual_exit" | "abandoned"
  is_news_event BOOLEAN DEFAULT false,
  pre_trade_checklist_passed BOOLEAN DEFAULT false,
  post_trade_reflection TEXT
);

CREATE TABLE IF NOT EXISTS trade_events (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  trade_id UUID NOT NULL REFERENCES trades(id) ON DELETE CASCADE,
  event_type TEXT NOT NULL,
  old_data JSONB,
  new_data JSONB,
  reason TEXT,
  created_at TIMESTAMPTZ DEFAULT NOW(),
  CONSTRAINT valid_event_type CHECK (event_type IN ('CREATED', 'EDITED', 'STOP_MOVED', 'TP_MOVED', 'PARTIAL_EXIT', 'FULL_EXIT', 'NOTE_ADDED', 'RULE_VIOLATION'))
);

CREATE INDEX IF NOT EXISTS idx_trade_events_trade_id ON trade_events(trade_id);
CREATE INDEX IF NOT EXISTS idx_trade_events_created_at ON trade_events(created_at);

-- Missing columns on trades table (run ALTER if table already exists)
ALTER TABLE trades ADD COLUMN IF NOT EXISTS user_id UUID;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS account_id UUID;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS commissions NUMERIC;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS fees NUMERIC;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS risk_reward NUMERIC;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS entry_time TEXT;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS exit_time TEXT;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS focus_level INTEGER;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS rule_adherence INTEGER;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS impulsiveness INTEGER;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS energy_level INTEGER;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS market_context INTEGER;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS outcome_satisfaction INTEGER;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS confidence_level INTEGER;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS post_trade_emotion TEXT;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS what_to_improve TEXT;
ALTER TABLE trades ADD COLUMN IF NOT EXISTS import_source TEXT DEFAULT NULL;

-- Profiles table (persists MDD, max daily trades, display name, preferences)
CREATE TABLE IF NOT EXISTS profiles (
  id UUID PRIMARY KEY REFERENCES auth.users(id) ON DELETE CASCADE,
  display_name TEXT,
  max_daily_drawdown NUMERIC DEFAULT 400,
  max_daily_trades INTEGER DEFAULT 10,
  strategy_preferences JSONB DEFAULT '{}',
  created_at TIMESTAMPTZ DEFAULT NOW(),
  updated_at TIMESTAMPTZ DEFAULT NOW()
);

-- Custom strategies table
CREATE TABLE IF NOT EXISTS custom_strategies (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  user_id UUID NOT NULL,
  name TEXT NOT NULL,
  description TEXT,
  enabled BOOLEAN DEFAULT true,
  created_at TIMESTAMPTZ DEFAULT NOW()
);

-- Accounts table
CREATE TABLE IF NOT EXISTS accounts (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  user_id UUID NOT NULL,
  name TEXT NOT NULL,
  broker TEXT,
  account_type TEXT DEFAULT 'live',
  starting_balance NUMERIC DEFAULT 10000,
  created_at TIMESTAMPTZ DEFAULT NOW()
);

-- Instrument settings (user-configurable tick size/value per symbol)
CREATE TABLE IF NOT EXISTS instrument_settings (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  user_id UUID NOT NULL,
  symbol TEXT NOT NULL,
  tick_size NUMERIC NOT NULL DEFAULT 0.25,
  tick_value NUMERIC NOT NULL DEFAULT 5.00,
  description TEXT,
  created_at TIMESTAMPTZ DEFAULT NOW(),
  UNIQUE(user_id, symbol)
);

-- Daily notes
CREATE TABLE IF NOT EXISTS daily_notes (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  user_id UUID NOT NULL,
  account_id UUID,
  note_date DATE NOT NULL,
  notes TEXT,
  created_at TIMESTAMPTZ DEFAULT NOW(),
  UNIQUE(user_id, account_id, note_date)
);
`;
